export default __webpack_public_path__ + "static/media/topic0-dialog.a81abd33.png";